import React from 'react';
import {useTranslation} from 'react-i18next';
import {useUserContext} from 'authentication/UserContext';
import {ConfirmAggregateDialog} from 'components/Dialogs/ConfirmAggregateDialog/ConfirmAggregateDialog';
import {usePreviewKeywordSuccessorsMutation} from '../hooks/keywords.generated';

export const PreviewKeywordSuccessorsButton: React.FC = () => {
	const {t} = useTranslation('features/adminsection', {
		keyPrefix: 'AdminKeywordsPage',
	});

	const [previewKeywordSuccessors] = usePreviewKeywordSuccessorsMutation();

	const {isAdmin} = useUserContext();

	const handleConfirm = () => {
		previewKeywordSuccessors();
	};

	return (
		<ConfirmAggregateDialog
			buttonKey='previewKeywordSuccessors'
			buttonText={t('PreviewKeywordSuccessors')}
			buttonHidden={!isAdmin}
			handleConfirm={handleConfirm}
			dialogTitle={t('PreviewKeywordSuccessors')}
			dialogText={t('PreviewKeywordSuccessorsText')}
		/>
	);
};
